export default __webpack_public_path__ + "images/139b233f51901cd389d4870e6b6ed49d.svg";